module.exports = __webpack_public_path__ + "img/taxi-top-view.2b9e5ab2.png";